import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { genericApi } from '../../../../common/apiconfig';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import StickyNotes from '../../../../../globalcomponents/stickyNotes/stickyNotes'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import CircularProgress from '@material-ui/core/CircularProgress';

const Notes = (propsobj) => {
  let [progress, setProgress] = useState(false);
  const [showForm, setshowForm] = useState(false);
  const [error, setError] = useState(null);
  const [notesData, setNotesData] = useState(null);;
  const addNote = () => {
    propsobj.history.push('/account/studyDetails/site/siteDetails/notes/addNotes');
    setshowForm(!showForm);
  }
  // const notesData = {
  //   "data": {
  //     "getStudySiteNote": [
  //       {
  //         "sn": {
  //           "noteId": "35",
  //           "studyId": "5000013",
  //           "siteId": "600012",
  //           "notes": "test note",
  //           "title": "title",
  //           "noteType": "External",
  //           "createdBy": "admin",
  //           "createdTs": "2023-12-02 03:27:13.0",
  //           "modifiedBy": "admin",
  //           "modifiedTs": "2023-12-02 03:27:13.0"
  //         },
  //         "link": [
  //           {
  //             "ID": "1536",
  //             "buArea": "Notes",
  //             "buid": "35",
  //             "type": "Link",
  //             "status": "Y",
  //             "detail1": "www.link1.com",
  //             "detail2": "desc",
  //             "detail3": "null",
  //             "detail4": "null",
  //             "addedById": "125809",
  //             "addedByName": "Admin",
  //             "addedTs": "2023-12-02 03:27:13.0"
  //           },
  //           {
  //             "ID": "1537",
  //             "buArea": "Notes",
  //             "buid": "35",
  //             "type": "Link",
  //             "status": "Y",
  //             "detail1": "www.link2.com",
  //             "detail2": "desc",
  //             "detail3": "null",
  //             "detail4": "null",
  //             "addedById": "125809",
  //             "addedByName": "Admin",
  //             "addedTs": "2023-12-02 03:27:13.0"
  //           }
  //         ],
  //         "document": [],
  //         "video": []
  //       }
  //     ]
  //   }
  // }

  const fetchNotes = async () => {
    let form = propsobj.formValues;

    if (!form?.studyId || !form?.siteId) {
      console.error("Missing required parameters: studyId or siteId");
      setError("Missing required data.");
      return;
    }

    let requestBody = JSON.stringify({
      query: `
        query {
            getStudySiteNote(studyId: "${form.studyId}", siteId: "${form.siteId}", noteType: "*", noteId: "*") {
                sn {
                    noteId
                    studyId
                    siteId
                    notes
                    title
                    noteType
                    createdBy
                    createdTs
                    modifiedBy
                    modifiedTs
                }
                     link {
      ID
      buArea
      buid
      type
      status
      detail1
      detail2
      detail3
      detail4
      addedById
      addedByName
      addedTs
    }
    document {
      ID
      buArea
      buid
      type
      status
      detail1
      detail2
      detail3
      detail4
      addedById
      addedByName
      addedTs
    }
    video {
      ID
      buArea
      buid
      type
      status
      detail1
      detail2
      detail3
      detail4
      addedById
      addedByName
      addedTs
    }
            }
        }`
    });
    setProgress(true);

    try {
      let res = await genericApi("getStudySiteNote", requestBody);
      setProgress(false);
      console.log("API Response:", res);
      if (res?.data?.getStudySiteNote) {
        setNotesData(res.data.getStudySiteNote);
      } else {
        setError("Error fetching notes data.");
      }
    } catch (err) {
      console.error("Error fetching study notes:", err);
      setError("Failed to fetch data.");
    }
  };


  const handleNoteDeleted = () => {
    fetchNotes();
  };


  useEffect(() => {
    fetchNotes();
  }, [propsobj.formValues]);
  const accountType = localStorage.getItem('whichApp');

  return (
    <>
      {progress && <div className="fullScreen">
        <CircularProgress
          disableShrink
          className="progressCircle"
          value={90}
          size={100}
          thickness={1.5}

        />
      </div>}



      <div className='d-flex flex-row'>
        <div className="d-flex flex-column">
          <p class="secondary-header mr-auto">Notes</p>
          <AddCircleIcon style={{ color: "#4169E1", fontSize: '50px', margin: '0px', cursor: 'pointer', paddingBottom: '5px' }} onClick={addNote} />
          {[
            "#FFF380",
            "#FFB6C1",
            "#90EE90",
            "#FFD580",
            "#FF1493"
          ].map((color, index) => (
            <FiberManualRecordIcon key={index} style={{ color, marginLeft: '9px' }} />
          ))}
        </div>
        <div className='m-5' style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)', // 4 equal columns 
          gap: '10px'
        }}>
          <StickyNotes data={notesData} onDelete={handleNoteDeleted} accountType={accountType} />
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    formValues: state.form,
    state
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateFormField: (obj) => {
      return dispatch(
        {
          type: 'UpdateFormField',
          value: obj.value,
          name: obj.name
        }
      )
    },
    clearForm: () => {
      return dispatch(
        {
          type: 'ClearForm',
        }
      )
    },
    updateErrorObj: (obj) => {
      return dispatch(
        {
          type: 'updateErrorObj',
          flag: obj.flag,
          name: obj.name,
          text: obj.text
        }
      )
    },
    updateEntireErrorObj: (errobj, errtextobj) => {
      return dispatch(
        {
          type: 'updateEntireErrorObj',
          errobj: errobj,
          errtextobj: errtextobj,
        }
      )
    },
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Notes));